import { render, staticRenderFns } from "./Alarmlog.vue?vue&type=template&id=3552d490&scoped=true"
import script from "./Alarmlog.vue?vue&type=script&lang=js"
export * from "./Alarmlog.vue?vue&type=script&lang=js"
import style0 from "./Alarmlog.vue?vue&type=style&index=0&id=3552d490&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3552d490",
  null
  
)

export default component.exports